import { Component, Host, h, Prop, State } from "@stencil/core";

const textGerman  = `Um unsere Webseite für Sie optimal zu gestalten und fortlaufend zu verbessern, die Nutzung zu analysieren und personalisierte Werbung zu schalten, verwenden wir Cookies und ähnliche Technologien. `;
const textFrench  = `Afin de vous offrir un site web optimal, de l'améliorer en permanence, d'analyser son utilisation et d'afficher des publicités personnalisées, nous utilisons des cookies et des technologies similaires. `;
const textItalian = `Utilizziamo i cookie e tecnologie simili per offrirvi un'esperienza di navigazione ottimizzata, migliorare costantemente il nostro sito, analizzarne l'utilizzo e attivare pubblicità personalizzate. `;
const textEnglish = `We use cookies and related technologies to optimize and constantly improve our website, analyse usage, and display personalized advertising. `;


const linkGerman  = 'Erfahren Sie mehr.'
const linkFrench  = 'En savoir plus.'
const linkItalian = 'Scopri di più.'
const linkEnglish = 'Find out more.'

@Component({
  tag: 'swc-cookie-banner',
  styleUrl: 'swc-cookie-banner.scss',
  shadow: true,
})
export class swcCookieBanner {

  /**
   * The language for the cookie banner text
   */
  @Prop() language: 'de' | 'fr' | 'it' | 'en' = 'de';

  /**
   * The URL to the privacy policy page
   */
  @Prop() link!: string;

  /**
   * The color for the text
   */
  @Prop() textColor: '#ffffff';

  /**
   * The font family for the text
   */
  @Prop() fontFamily: 'coopregular';

  /**
   * The Background color for the banner
   */
  @Prop() backgroundColor: 'rgba(0, 0, 0, 0.8)';

  /**
   * The state which defines if the banner is getting displayed or not
   */
  @State() display = true;

  getText() {
    switch (this.language) {
      case "de":
        return textGerman;
      case "fr":
        return textFrench;
      case "it":
        return textItalian;
      case "en":
        return textEnglish;
      default :
        return textGerman;
    }
  }

  getLink() {
    switch (this.language) {
      case "de":
        return linkGerman;
      case "fr":
        return linkFrench;
      case "it":
        return linkItalian;
      case "en":
        return linkEnglish;
      default :
        return linkGerman;
    }
  }

  closeBanner() {
    this.display = false;

    const expireDate = new Date();
    expireDate.setMonth(expireDate.getMonth() + 6);

    document.cookie = `privacyPolicyAccepted=true;expires=${expireDate};path=/`
  }

  getCookie(name) {
    const cookies = document.cookie.split(';');
    for(let i = 0; i <cookies.length; i+=1) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return "";
  }

  componentWillLoad() {
    const cookie = this.getCookie('privacyPolicyAccepted=');
    if(cookie) {
      this.display = false;
    }
  }

  render() {
    return (
      <Host>
        <style>{`
          .swc-cookie-banner {
            --text-color: ${this.textColor};
            --font-family: ${this.fontFamily};
            --background-color: ${this.backgroundColor};
          }
        `}</style>
        <div class={`swc-cookie-banner ${this.display ? '' : 'hide'}`}>
          <p class={'text'}>
            {this.getText()}<a href={this.link} target="_blank">{this.getLink()}</a>
          </p>
          <div class={'close'} onClick={() => this.closeBanner()}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="23.2256" width="32.8461" height="1.09487" transform="rotate(-45 0 23.2256)" fill={this.textColor}/>
              <rect x="0.77417" width="32.8461" height="1.09487" transform="rotate(45 0.77417 0)" fill={this.textColor}/>
            </svg>
          </div>
        </div>
      </Host>
    );
  }
}
